import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetTullkontorCommand extends BasicCommand<SetTullkontorCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    tullkontorId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetTullkontorCommand";
    constructor(init: (instance: SetTullkontorCommand) => void) {
        super("SetTullkontorCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
